"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimulatedPresenceDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const SimulatedPerson_dto_1 = require("./SimulatedPerson.dto");
class SimulatedPresenceDto {}
exports.SimulatedPresenceDto = SimulatedPresenceDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: SimulatedPerson_dto_1.SimulatedPersonDto
}), __metadata("design:type", SimulatedPerson_dto_1.SimulatedPersonDto)], SimulatedPresenceDto.prototype, "person", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SimulatedPresenceDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SimulatedPresenceDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], SimulatedPresenceDto.prototype, "venueLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], SimulatedPresenceDto.prototype, "venueLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'ISO timestamp when the persona was spawned into the venue.'
}), __metadata("design:type", String)], SimulatedPresenceDto.prototype, "checkedInAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], SimulatedPresenceDto.prototype, "secondsInVenue", void 0);
//# sourceMappingURL=SimulatedPresence.dto.js.map